import { takeLatest, all, call, put, select } from "redux-saga/effects";
import { updateCliente, allClientes as allClientesAction, resetClientes} from "./actions";
import types from "./types";
import {api} from "../../../services/api";
import consts from "../../../consts";
import cliente from "./reducer";
import { decode as base64_decode, encode as base64_encode } from "base-64";

export function* allClientes() {
  const { form, auth ,clientes} = yield select((state) => state.cliente);
  try {
    yield put(updateCliente({ form: { ...form, filtering: true } }));
    const { data: res } = yield call(api.get, `/users`,{
      headers: {
        Authorization: `Bearer ${
          auth.id.length === 0 ? sessionStorage.getItem("token") : auth.id
        }`,
      },
    });
    yield put(updateCliente({ form: { ...form, filtering: false } }));
    if (res.error) {
      alert(res.message);

      return false;
    }
    
    yield put(updateCliente({ clientes: res }));
 
  } catch (error) {
    yield put(updateCliente({ form: { ...form, filtering: false } }));
    alert(error.message);
  
  }
}

export function* filterClientes() {
  const { form, cliente, auth } = yield select((state) => state.cliente);
  try {
    yield put(updateCliente({ form: { ...form, filtering: true } }));
    const { data: res } = yield call(api.get, `/users/${sessionStorage.getItem("id")}`, {
      headers: {
        Authorization: `Bearer ${
          auth.id.length === 0 ? sessionStorage.getItem("token") : auth.id
        }`,
      },
    });

    yield put(updateCliente({ cliente: res }));
    yield put(updateCliente({ form: { ...form, filtering: false } }));
    if (res.error) {
      alert(res.message);

      return false;
    }

    if (cliente.length > 0) {
      yield put(
        updateCliente({
          cliente: res,
          form: { ...form, filtering: false, disable: false },
        })
      );
    } else {
      yield put(updateCliente({ form: { ...form, disable: false } }));
    }
  } catch (error) {
    yield put(updateCliente({ form: { ...form, filtering: false } }));
    alert(error.message);
  }
}
export function* filterClientesCnh() {
  const { form, cliente, auth ,users_licenses } = yield select((state) => state.cliente);
  try {
    yield put(updateCliente({ form: { ...form, filtering: true } }));
    const { data: res } = yield call(api.get, `/users/license/${sessionStorage.getItem("id")}`, {
      headers: {
        Authorization: `Bearer ${
          auth.id.length === 0 ? sessionStorage.getItem("token") : auth.id
        }`,
      },
    });

    yield put(updateCliente({ users_licenses: res }));
    yield put(updateCliente({ form: { ...form, filtering: false } }));
    if (res.error) {
      alert(res.message);

      return false;
    }

    if (cliente.length > 0) {
      yield put(
        updateCliente({
          cliente: res,
          form: { ...form, filtering: false, disable: false },
        })
      );
    } else {
      yield put(updateCliente({ form: { ...form, disable: false } }));
    }
  } catch (error) {
    yield put(updateCliente({ form: { ...form, filtering: false } }));
    alert(error.message);
  }
}

export function* addCliente() {
  const { form, cliente, components, step1, step2 ,steps} = yield select((state) => state.cliente);


  try {
    
  
    yield put(updateCliente({ form: { ...form, saving: true } }));
    yield put(updateCliente({ form: { ...form, filtering: true } }));
   
   yield put(updateCliente({ form: { ...form, codeOk: false } }));

    const { data: res } = yield call(api.post, `/register/1`,  {
      email: step1.email,
      name: step1.name,
      phone_number: step1.phone_number

    });


    yield put(updateCliente({ steps: { ...steps, id: 2 } }));
    yield put(updateCliente({ step2: { ...step2, id: res.id} }));   
    yield put(updateCliente({ code: { id: res.code} }));   
    yield put(updateCliente({ form: { ...form, saveDataForm: true } }));
    yield put(updateCliente({ form: { ...form, saving: false} }));
  

    if (res.error) {
   
      yield put(updateCliente({ steps: { ...steps, id: 1 } }));
      yield put(updateCliente({ form: { ...form, saveDataForm: false } }));
   
      return false;
    }


    yield put(updateCliente({ components: { ...components, drawer: false } }))
    yield put(resetClientes())
  
  } catch (error) {
 

    alert(error.response.data.message);
  }
 
}

export function* stepCodeInsert() {
  const { form, cliente, components, step1, step2 , code, codeOk, steps} = yield select((state) => state.cliente);
  console.log("stepCodeInsert", code.id,form.decode )
  try {
   
    
      if(base64_decode(code.id) === base64_decode(form.decode)){
        console.log("stepCodeInsert + dentro")
        yield put(updateCliente({ codeOk: { id :true} }));
    yield put(updateCliente({ form: { ...form, saving: true } }));
    yield put(updateCliente({ form: { ...form, filtering: true } }));
   yield put(updateCliente({ steps: { ...steps, id: 2} }));
  
   }else{
    return 
   }
    
  } catch (error) {
    
    alert(error.response.data.message +"active");

    yield put(updateCliente({ form: { ...form, saving: false } }));
  }
}

export function* addClientesStepTwo() {
  const { form, cliente, components, step1, step2 , steps } = yield select((state) => state.cliente);
  try {
    console.log("fora de saga step2")
    yield put(updateCliente({ form: { ...form, saving: true } }));
    yield put(updateCliente({ form: { ...form, filtering: true } }));
  //yield put(updateCliente({ form: { ...form, steps: 1} }));
   
    const { data: res } = yield call(api.post, `/register/2`, {
      id: step2.id,
      cpf: step2.cpf,
      address:step2.address,
      address_number: step2.address_number,
      address_complement: step2.address_complement,
      address_district:step2.address_district,
      address_city: step2.address_city,
      address_state: step2.address_state,
      address_zipcode: step2.address_zipcode,
      password: step2.password

    });
    console.log("fora de finalizo step2", res)

    yield put(updateCliente({ cliente: { ...step2, id: res.id} }));
    yield put(updateCliente({ cliente: { ...step2, id: res.id} }));
    yield put(updateCliente({ steps: { ...steps, id: 1} }));
    yield put(updateCliente({ form: { ...form, saving: false} }));
  
    if (res.error) {
      alert(res.message);

      return false;
    }

    yield put(allClientesAction())
    yield put(updateCliente({ components: { ...components, drawer: false } }))
    yield put(resetClientes())
  
  } catch (error) {
    
    yield put(updateCliente({ form: { ...form, saving: false } }));
    
    alert(error.response.data.message);
  }
}


export function* unlinkClientes() {
  const { form, cliente, components } = yield select((state) => state.cliente);
  try {
    yield put(updateCliente({ form: { ...form, saving: true } }));
    const { data: res } = yield call(api.delete, `/clientes/vinculo/${cliente.vinculoId}`);
    yield put(updateCliente({ form: { ...form, saving: false  } ,
    }));
    if (res.error) {
      alert(res.message);

      return false;
    }

    yield put(allClientesAction())
    yield put(updateCliente({ components: { ...components, drawer: false , confirmDelete: false} }))
    yield put(resetClientes())
  
  } catch (error) {
    yield put(updateCliente({ form: { ...form, saving: false } }));
    alert(error.response.data.message);
  }
}

export function* updateDataCliente(){
  const { form, auth ,cliente} = yield select((state) => state.cliente);
  try {
    yield put(updateCliente({ form: { ...form, filtering: true } }));
    const { data: res } = yield call(api.put, `/users/${cliente.id}`,
    cliente
    
    
    ,{
      headers: {
        Authorization: `Bearer ${
          auth.id.length === 0 ? sessionStorage.getItem("token") : auth.id
        }`,
      },
    });
    yield put(updateCliente({ form: { ...form, filtering: false } }));
    if (res.error) {
      alert(res.message);

      return false;
    }
    
    yield put(updateCliente({ clientes: res }));
 
  } catch (error) {
    yield put(updateCliente({ form: { ...form, filtering: false } }));
    alert(error.message);
  
  }



}





export function* loginSessionIn() {

  const { form, loginCliente, auth,cliente } = yield select((state) => state.cliente);

var header= {  headers: { 
  'Content-Type': 'application/json'
},}
  try {
    
    yield put(updateCliente({ form: { ...form, saving: true } }));
    const  {data: res}  = yield call(api.post,`/login`, {email:loginCliente.email,  password: loginCliente.password});

    yield put(updateCliente({ form: { ...form, saving: false } }));
    yield put(updateCliente({ auth: { id: res.token } }));
    sessionStorage.setItem("token",`${res.token }`)
    sessionStorage.setItem("id",`${res.id }`)
    sessionStorage.setItem("name",`${res.name }`)
    sessionStorage.setItem("email",`${res.email }`)
    sessionStorage.setItem("active",true)
    sessionStorage.setItem("isAdmin",`${res.isAdmin }`)

    yield put(updateCliente({ cliente: {...cliente,  
      id: res.id,
      name: res.name,
      email:res.email,        
      active: true,
      isAdmin: res.isAdmin
    
    } }));
 
    if (res.error) {
     
      yield put(updateCliente({ form: { ...form, fail: true } }));
      yield put(updateCliente({ form: { ...form, errorTag: "Email ou senha errada" } }));
      alert(res.message);
      return false;
    }
 
    if (res.length > 0) {
      yield put(
        updateCliente({
       
          cliente: res.clientes[0],
          form: { ...form, filtering: false, disable: false },
        })
      );
      yield put(updateCliente({ form: { ...form, fail: false } }));
      yield put(updateCliente({ form: { ...form, errorTag: "login" } }));
    } else {
      yield put(updateCliente({ form: { ...form, disable: false } }));
    }
  } catch (error) {
    yield put(updateCliente({ form: { ...form, filtering: false } }));
   yield put(updateCliente({ form: { ...form, fail: true } }));
   
  yield put(updateCliente({ form: { ...form, errorTag: `${error}` } }));

  alert(error.response.data.message);
  }
}



export function* sessionLogOut (){
  const { form, loginCliente, auth,cliente } = yield select((state) => state.cliente);


    try {
      
     
      yield put(updateCliente({ auth: { id: "" } }));
      sessionStorage.setItem("token",``)
     
      sessionStorage.setItem("id","")
      sessionStorage.setItem("name","")
      sessionStorage.setItem("email","")
      sessionStorage.setItem("active",false)
      yield put(updateCliente({ cliente: {...cliente,  
        id: "",
        name: "",
        email:"",        
        active: false} }));       
   
     
       

      }
     catch (error) {
      yield put(updateCliente({ form: { ...form, filtering: false } }));
     yield put(updateCliente({ form: { ...form, fail: true } }));
     
    yield put(updateCliente({ form: { ...form, errorTag: `${error}` } }));
  
    alert(error.response.data.message);
    }
}


export function* cnhUpdate(){
  const { form, auth ,cliente, users_licenses} = yield select((state) => state.cliente);



  
     const buffer = async()=> await  users_licenses.photo.arrayBuffer();
     const bytes = new Uint8Array(buffer);
     const dataForm = new FormData()
     dataForm.append("number", users_licenses.number)
     dataForm.append("valid_to", users_licenses.valid_to)
     dataForm.append("category", users_licenses.category)
     dataForm.append("users_id", sessionStorage.getItem("id"))
     dataForm.append("photo",users_licenses.photo)

 
  try {
    yield put(updateCliente({ form: { ...form, filtering: true } }));
    const { data: res } = yield call(api.post, `/users/license/${sessionStorage.getItem("id")}`,
  
    
    dataForm
  
    
    ,{
      headers: {
        "content-type": "multipart/form-data",
        Authorization: `Bearer ${
          auth.id.length === 0 ? sessionStorage.getItem("token") : auth.id
        }`,
      },
    });
    yield put(updateCliente({ form: { ...form, filtering: false } }));
    if (res.error) {
      alert(res.message);

      return false;
    }
    
  
    yield put(updateCliente({ result: res.result }));
 
  } catch (error) {
    yield put(updateCliente({ form: { ...form, filtering: false } }));
    alert(error.message);
  
  }
}





export default all([
  takeLatest(types.ALL_CLIENTES, allClientes),
  takeLatest(types.UPDATE_DATA_CLIENTE, updateDataCliente),
  takeLatest(types.UPDATE_CNH_CLIENTE, cnhUpdate),
  takeLatest(types.FILTER_CLIENTES, filterClientes),
  takeLatest(types.FILTER_CLIENTES_CNH, filterClientesCnh),
  takeLatest(types.ADD_CLIENTES, addCliente),
  takeLatest(types.ADD_STEP_CODE_INSERT, stepCodeInsert),
  takeLatest(types.ADD_CLIENTES_TWO, addClientesStepTwo),
  takeLatest(types.UNLINK_CLIENTES, unlinkClientes),
  takeLatest(types.LOGIN_SESSION_IN, loginSessionIn),
  takeLatest(types.LOGIN_SESSION_OUT, sessionLogOut),
]);
